import { useEffect, useMemo, useState } from "react";
import useAxiosInstance from "../../../../../Utilities/Hooks/useAxiosInstance";
import "./inventory-modals.css";

export default function BackfillBarcodesModal({ productSizeId, onClose, onSuccess }) {
  const axios = useAxiosInstance();

  const [loading, setLoading] = useState(false);
  const [stats, setStats]     = useState({ total: 0, existing: 0, missing: 0, locationOnHand: {} });

  const [mainOffice, setMainOffice] = useState(0);
  const [showRoom,   setShowRoom]   = useState(0);
  const [wareHouse,  setWareHouse]  = useState(0);

  const [error, setError] = useState("");
  const [okMsg, setOkMsg] = useState("");

  useEffect(() => {
    let ignore = false;
    async function fetchMissing() {
      try {
        const { data } = await axios.get(
          `https://api.stridesco.com/api/employee/inventory/stockUnits/missing/${productSizeId}`
        );
        if (!ignore) setStats(data || { total: 0, existing: 0, missing: 0, locationOnHand: {} });
      } catch {
        if (!ignore) setStats({ total: 0, existing: 0, missing: 0, locationOnHand: {} });
      }
    }
    fetchMissing();
    return () => { ignore = true; };
  }, [axios, productSizeId]);

  const sumAlloc = useMemo(
    () => (Number(mainOffice)||0) + (Number(showRoom)||0) + (Number(wareHouse)||0),
    [mainOffice, showRoom, wareHouse]
  );

  async function submitBackfill(e) {
    e.preventDefault();
    setError(""); setOkMsg("");

    if (stats.missing <= 0) return setError("No missing barcodes to mint.");
    if (sumAlloc !== stats.missing) {
      return setError(`Your split (${sumAlloc}) must equal the missing count (${stats.missing}).`);
    }

    try {
      setLoading(true);
      const { data } = await axios.post(`https://api.stridesco.com/api/employee/inventory/stockUnits/backfill`, {
        productSizeId,
        allocations: {
          mainOffice: Number(mainOffice) || 0,
          showRoom:   Number(showRoom)   || 0,
          wareHouse:  Number(wareHouse)  || 0,
        },
      });
      setOkMsg(`Minted ${data?.minted || 0} barcodes.`);
      setMainOffice(0); setShowRoom(0); setWareHouse(0);

      // refresh missing stats
      const { data: fresh } = await axios.get(
        `https://api.stridesco.com/api/employee/inventory/stockUnits/missing/${productSizeId}`
      );
      setStats(fresh || { total: 0, existing: 0, missing: 0, locationOnHand: {} });

      if (onSuccess) onSuccess(data);
    } catch (err) {
      setError(err?.response?.data?.error || "Backfill failed.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="inv-modal">
      <div className="inv-modal__title">Backfill Barcodes</div>

      <div className="inv-modal__section">
        <div className="inv-metrics">
          <div className="inv-metric"><span>Total</span><strong>{stats.total}</strong></div>
          <div className="inv-metric"><span>Existing Barcodes</span><strong>{stats.existing}</strong></div>
          <div className="inv-metric inv-metric--missing"><span>Missing</span><strong>{stats.missing}</strong></div>
        </div>
      </div>

      <form onSubmit={submitBackfill} className="inv-form">
        <div className="inv-row">
          <div className="inv-col">
            <label className="inv-label">Main Office</label>
            <input type="number" min="0" className="inv-input"
              value={mainOffice}
              onChange={(e)=>setMainOffice(e.target.value)} />
          </div>
          <div className="inv-col">
            <label className="inv-label">Showroom</label>
            <input type="number" min="0" className="inv-input"
              value={showRoom}
              onChange={(e)=>setShowRoom(e.target.value)} />
          </div>
          <div className="inv-col">
            <label className="inv-label">Warehouse</label>
            <input type="number" min="0" className="inv-input"
              value={wareHouse}
              onChange={(e)=>setWareHouse(e.target.value)} />
          </div>
        </div>

        <div className="inv-help">
          Split must equal <strong>{stats.missing}</strong>. Current sum: <strong>{sumAlloc}</strong>
        </div>

        {error && <div className="inv-alert inv-alert--error">{error}</div>}
        {okMsg && <div className="inv-alert inv-alert--ok">{okMsg}</div>}

        <div className="inv-actions">
          <button type="button" className="inv-btn inv-btn--ghost" onClick={onClose}>Close</button>
          <button type="submit" className="inv-btn inv-btn--primary" disabled={loading || stats.missing<=0}>
            {loading ? "Minting…" : "Mint Barcodes"}
          </button>
        </div>
      </form>
    </div>
  );
}
